import request from "../Tools/request/request";

// 应用开通-列表
export function getAppList(data) {
    return request({
        url: "/supermarket/app/openlist",
        method: "post",
        data,
    });
}
// 实例资源-列表
export function getResourceList(data) {
    return request({
        url: "/builder/server-instance/list",
        method: "post",
        data,
    });
}
// 服务接入-列表
export function getServiceList(data) {
    return request({
        url: "/builder/app-server/list",
        method: "post",
        data,
    });
}
// 应用开通-审核
export function getAppReview(data) {
    return request({
        url: "/supermarket/app-open/review",
        method: "post",
        data,
    });
}

// 实例资源-审核
export function getResourceReview(data) {
    return request({
        url: "/builder/review",
        method: "post",
        data,
    });
}   

//后台-运营收入明细-应用开通
export function getAppIncomingList(data) {
    return request({
        url: "/supermarket/app/app-incoming/list",
        method: "post",
        data,
    });
}